import { useContext, useEffect, useRef, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import About from '../pages/About';
import Contact from '../pages/Contact';
import Gallery from '../pages/Gallery';
import Home from '../pages/Home';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import MenuIcon from './hamburger';

const Navbar = () => {
    const navigate = useNavigate();
    const { pAuth, setPAuth } = useContext(AuthContext);

    const SERVER_URL = process.env.NODE_ENV === 'development' ?
        process.env.REACT_APP_DEV_SERVER_URL : process.env.REACT_APP_PROD_SERVER_URL;

    const navButton = useRef(null);
    const linksContainerRef = useRef(null);
    const collapseNav = () => {
        navButton.current.classList.add("collapsed");
        linksContainerRef.current.classList.remove("show");
        var element = document.getElementById("menu");
        element.classList.toggle("active");
    }


    const handleLogout = () => {
        fetch(`${SERVER_URL}/dologout`, {
            method: 'POST',
            credentials: 'include'
        }).then(res => {
            if (res.status === 200) {
                setPAuth(false);
                navigate('/');
            }
        });
    }

    const checkAuth = () => {
        fetch(`${SERVER_URL}/checkAuth`, {
            method: 'GET',
            headers: {
                Accept: "application/json",
                'Content-Type': 'application/json',
                "Access-Control-Allow-Credentials": true
            },
            credentials: 'include'
        }).then(response => response.json())
            .then((data) => {
                if (data.isAuthorised) {
                    setPAuth(true);
                } else setPAuth(false);
            })
            .catch(err => console.log(err));
    }

    useEffect(() => {
        checkAuth();
    }, []);

    return (
        <nav className="main-nav navbar navbar-expand-md navbar-light px-2 px-md-5 justify-content-between">
            <NavLink to="/" onClick={collapseNav}>
                <img className='brand-logo' src="\assets/icons/brand-logo-mini-orange.svg" alt="brand-logo" />
                {/* <img id='brand-logo-full' src="/assets/icons/brand-logo-full.svg" alt="brand-logo" /> */}
                <img className='brand-logo-full' src="/assets/icons/brand-logo-orange.svg" alt="brand-logo" />
            </NavLink>

            <button id="menu-button" className="navbar-toggler" type="button"
                ref={navButton}
                data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false"
                aria-label="Toggle navigation">
                <MenuIcon />
                {/* <img src="/assets/icons/menu.svg" alt="menu" /> */}
            </button>


            <div className="collapse navbar-collapse mt-3 justify-content-end"
                id="navbarSupportedContent"
                ref={linksContainerRef}
            >
                <ul className="navbar-nav">
                    <li className="nav-item px-1 mx-md-1 mx-lg-3"
                        // data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"
                        onClick={collapseNav}
                    >
                        <NavLink className='nav-link' to="/" element={<Home />}>HOME</NavLink>
                    </li>
                    <li className="nav-item px-1 mx-md-1 mx-lg-3"
                        // data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"
                        onClick={collapseNav}
                    >
                        <NavLink className='nav-link' to="/portfolio" element={<Gallery />}>PORTFOLIO</NavLink>
                    </li>
                    <li className="nav-item px-1 mx-md-1 mx-lg-3"
                        // data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"
                        onClick={collapseNav}
                    >
                        <NavLink className='nav-link' to="/aboutus" element={<About />}>ABOUT</NavLink>
                    </li>
                    <li className="nav-item px-1 mx-md-1 mx-lg-3"
                        // data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"
                        onClick={collapseNav}
                    >
                        <NavLink className='nav-link' to="/contact" element={<Contact />}>CONTACT</NavLink>
                    </li>
                    {pAuth &&
                        <li className="nav-item px-1 mx-md-1 mx-lg-3"
                            // data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"
                            onClick={collapseNav}
                        >
                            <span className='nav-link' onClick={handleLogout}>LOGOUT</span>
                        </li>
                    }
                </ul>
            </div>

        </nav>
    );
}

export default Navbar;




// import { useRef } from "react";
// import { NavLink } from "react-router-dom";

// const Nav = () => {
//     const navButton = useRef(null);
//     const linksContainerRef = useRef(null);

//     function collapseNav() {
//         navButton.current.classList.add("collapsed");
//         linksContainerRef.current.classList.remove("show");
//     }

//     return (
//         <nav className="navbar navbar-expand-lg sticky-top navbar-light bg-light">
//             <div className="container-fluid">
//                 <NavLink onClick={collapseNav} className="navbar-brand" to="/">
//                     Navbar
//                 </NavLink>
//                 <button
//                     ref={navButton}
//                     className="navbar-toggler"
//                     type="button"
//                     data-bs-toggle="collapse"
//                     data-bs-target="#navbarNav"
//                     aria-controls="navbarNav"
//                     aria-expanded="false"
//                     aria-label="Toggle navigation"
//                 >
//                     <span className="navbar-toggler-icon"></span>
//                 </button>
//                 <div
//                     ref={linksContainerRef}
//                     className="collapse navbar-collapse"
//                     id="navbarNav"
//                 >
//                     <ul className="navbar-nav">
//                         <li className="nav-item">
//                             <NavLink
//                                 onClick={collapseNav}
//                                 className="nav-link active"
//                                 aria-current="page"
//                                 to="/"
//                             >
//                                 Home
//                             </NavLink>
//                         </li>
//                         <li className="nav-item">
//                             <NavLink onClick={collapseNav} className="nav-link" to="about">
//                                 About
//                             </NavLink>
//                         </li>
//                     </ul>
//                 </div>
//             </div>
//         </nav>
//     );
// };

// export default Nav;
